var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-list',{attrs:{"title":"Mining App Configs","items-per-page":500,"no-search-padding":"","search-by":[
      'Name',
      'Description' ],"show-filters":"","export-query-type":"workerMiningConfigsExport","query-fields":[
      'ID',
      'Name',
      'Description',

      'MiningAppTypeID',
      'MiningAppType {Name}',
      'MiningAppVersionID',
      'MiningAppVersion {Description}',

      'Config',

      'CreatedAt',
      'UpdatedAt' ],"delete-mutation-type":"deleteWorkerMiningConfig","delete-mutation-field":"ids","delete-by":"ID","add-link":"worker_mining_configs/add","query-type":"workerMiningConfigs","row-click":_vm.onRowClick},scopedSlots:_vm._u([{key:"head",fn:function(){return [_c('lth',{attrs:{"sort-by":"Name","width":"120"}},[_vm._v("Name")]),_c('lth',{attrs:{"sort-by":"Description","width":"120"}},[_vm._v("Description")]),_c('lth',[_vm._v("Mining App Type")]),_c('lth',[_vm._v("Mining App Version")]),_c('lth',{attrs:{"sort-by":"CreatedAt"}},[_vm._v("Created At")]),_c('lth',{attrs:{"sort-by":"UpdatedAt","width":"150"}},[_vm._v("Updated At")])]},proxy:true},{key:"row",fn:function(ref){
    var item = ref.item;
return [_c('ltd',[_vm._v(_vm._s(item.Name))]),_c('ltd',[_vm._v(_vm._s(item.Description))]),_c('ltd',[_vm._v(_vm._s(item.MiningAppType ? item.MiningAppType.Name : ""))]),_c('ltd',[_vm._v(_vm._s(item.MiningAppVersion ? item.MiningAppVersion.Description : ""))]),_c('ltd',{attrs:{"date":""}},[_vm._v(_vm._s(item.CreatedAt))]),_c('ltd',{attrs:{"date":""}},[_vm._v(_vm._s(item.UpdatedAt))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }